export default "aaed5bda1a47a2c8.svg"